import React, { Component } from "react";
import { connect } from "react-redux";
import { sendOrder, fetchPackages, fetchAvailability } from "../../Store/Slices/deploymentSlice";
import { fetchCredits } from "../../Store/Slices/creditSlice";

class DeploymentV2 extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeTab: "basic",
            selectedPackageId: null,

            resources: [],

            duration: 1,
            serverName: "",
            billingType: 0,

            validationError: ""
        };
    }

    componentDidMount() {
        this.props.fetchPackages();
        this.props.fetchCredits();

        const params = new URLSearchParams(window.location.search);
        const packageId = params.get("id");

        this.setState({ pendingPackageId: packageId });
    }

    componentDidUpdate() {
        const { pendingPackageId } = this.state;
        const { loading } = this.props;
        if (pendingPackageId !== null && loading === false) {
            this.updateField("selectedPackageId", pendingPackageId)
            this.setState({ pendingPackageId: null });
    }
    }

    // =========================
    // DATA
    // =========================
    getFilteredPackages = () => {
        const { packages } = this.props;
        const { activeTab } = this.state;

        return packages?.filter(
            p => (p.type || "").toLowerCase() === activeTab
        );
    };

    getSelectedPackage = () =>
        this.props.packages?.find(
            p => p.id === this.state.selectedPackageId
        );

    // =========================
    // UPDATE
    // =========================
    updateField = (field, value, i = null) => {
        const { billingType } = this.state;

        let newValue = value;
        if (field === "selectedPackageId") {
            this.setState({
                // reset dependent state
                selectedPackageId: null,
                serverName: "",
                resources: [],
                validationError: ""
            });
            if (value !== null) {
                this.props.fetchAvailability(value);
            }
        }
        else if (field === "duration" || field === "billingType") {
            if (billingType === 1) {
                newValue = Math.max(1, Math.min(12, parseInt(value || 1)));
            } else {
                newValue = Math.max(1, Math.min(24, parseInt(value || 1)));
            }
        }
        
        this.setState({ [field]: field === "billingType" ? parseInt(value): newValue }, this.validate);
    };

    updateResourceField = (index, field, value, id) => {
        this.setState(prev => {
            const resources = [...prev.resources];

            if (!resources[index]) {
                resources[index] = { ResourceId: "", region: "", size: "" };
            }

            resources[index] = {
                ...resources[index],
                [field]: value,
                ResourceId: id
            };

            return { resources };
        }, this.validate);
    };

    validate = () => {
        const { credits, sizes } = this.props;
        const { selectedPackageId, duration, serverName, billingType, resources } = this.state;

        let validationError = "";
        let isValid = true;
        let totalCost = 0;

        const selectedPackage = this.getSelectedPackage();
        if (selectedPackage) {
            if (billingType === 1) {
                totalCost = sizes.reduce((acc, r) => {
                    const size = sizes.find(s => s.slug === r.size);
                    return acc + (size?.price_monthly || 0);
                }, 0) * duration;
            } else {
                totalCost = resources.reduce((acc, r) => {
                    const size = sizes.find(s => s.slug === r.size);
                    return acc + (size?.price_hourly || 0);
                }, 0) * duration;
            }
        }

        if (totalCost >= parseFloat(credits?.toString().replace(/,/g, ''))) {
            validationError = "Insufficient Credits."
            isValid = false;
        }

        if (!serverName) {
            validationError = "System name is required.";
            isValid = false;
        }
        else if (!/^[a-z-A-Z0-9]+$/.test(serverName)) {
            validationError = "System name must be alphanumeric or -.";
            isValid = false;
        }
        else if (!duration || duration < 1) {
            validationError = "Duration must be at least 1 hour.";
            isValid = false;
        }
        else if (!selectedPackageId || selectedPackageId === "0") {
            validationError = "Please select a package.";
            isValid = false;
        }
        else if (resources.length !== selectedPackage.resources.length || resources.some(r => !r?.region)) {
            validationError = "Please Fill out Resource Regions";
            isValid = false;
        }
        else if (resources.length !== selectedPackage.resources.length || resources.some(r => !r?.size)) {
            validationError = "Please Fill out Resource Size";
            isValid = false;
        }

        this.setState({ validationError, isValid, totalCost });
        return isValid;
    };

    // =========================
    // TAB CHANGE (IMPORTANT FIX)
    // =========================
    handleTabChange = (tab) => {
        this.setState({
            activeTab: tab,

            // reset dependent state
            selectedPackageId: null,
            resources: [],
            validationError: ""
        });
    };

    // =========================
    // DEPLOY
    // =========================
    handleDeploy = async () => {
        if (!this.state.isValid) {
            this.setState({
                validationError: "Please complete all required fields."
            });
            return;
        }

        this.setState({ isValid: false })
        await this.props.sendOrder({
            PackageId: this.state.selectedPackageId,
            Resources: this.state.resources,
            Duration: this.state.duration,
            BillingType: this.state.billingType,
            DeploymentName: this.state.serverName
        });
        window.location = "/cp/packages";
        alert("Deployment Request Submitted, Redirecting to Dashboard..")
    };

    // =========================
    // TABS
    // =========================
    renderTabs() {
        const tabs = ["basic", "advanced", "enterprise"];
        const { activeTab } = this.state;

        return (
            <div className="flex gap-2 mb-6 flex-wrap">
                {tabs.map(tab => (
                    <button
                        key={tab}
                        onClick={() => this.handleTabChange(tab)}
                        className={`px-4 py-2 rounded-lg border text-sm font-medium transition ${activeTab === tab
                                ? "bg-slate-900 text-white"
                                : "bg-white hover:border-gray-400"
                            }`}
                    >
                        {tab.toUpperCase()}
                    </button>
                ))}
            </div>
        );
    }

    // =========================
    // PACKAGES
    // =========================
    renderPackages() {
        const packages = this.getFilteredPackages();
        const selected = this.state.selectedPackageId;

        if (!packages || packages.length === 0) {
            return (
                <div className="text-center py-12 border rounded-lg bg-gray-50 text-gray-500">
                    No packages available in this category.
                </div>
            );
        }

        return (
            <div className="space-y-3">
                {packages.map(pkg => {
                    const active = selected === pkg.id;

                    return (
                        <div
                            key={pkg.id}
                            onClick={() =>
                                this.updateField("selectedPackageId", pkg.id)
                            }
                            className={`p-4 border rounded-lg cursor-pointer transition ${active
                                    ? "border-slate-900 bg-slate-100"
                                    : "hover:border-gray-400 bg-white"
                                }`}
                        >
                            <div className="flex justify-between">
                                <div>
                                    <div className="font-semibold">
                                        {pkg.name}
                                    </div>
                                    <div className="text-sm text-gray-500">
                                        {pkg.description}
                                    </div>
                                </div>

                                {/*<div className="font-bold">*/}
                                {/*    ${pkg.price}/hr*/}
                                {/*</div>*/}
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }

    renderConfigResource(rss,i) {
        const { regions, sizes } = this.props;
        const { resources } = this.state;
        const selectedPackage = this.getSelectedPackage();

        let region = resources[i]?.region ?? "";
        let size = resources[i]?.size ?? "";
        
        return (
            <div className="space-y-4 pb-5" key={rss.i}>
                {/* HEADER */}
                <div className="flex justify-between items-center">
                    <div>
                        <div className="text-lg font-bold">
                            Resource: {rss.name}
                        </div>
                    </div>
                </div>
                <hr/>
                {/* REGION */}
                <label className="flex gap-2 text-sm items-start">Region</label>
                <select
                    className="w-full border p-2 rounded"
                    value={region}
                    onChange={(e) =>
                        this.updateResourceField(i, "region", e.target.value, rss.id)
                    }
                >
                    <option value="">Select Region</option>
                    {regions.filter(r => r.available === true).map(r => (<option value={r.slug}>{r.name}</option>))}
                </select>

                {/* SIZE */}
                {region && <>
                    <label className="flex gap-2 text-sm items-start">Size</label>
                    <select
                        className="w-full border p-2 rounded"
                        value={size}
                        onChange={(e) =>
                            this.updateResourceField(i, "size", e.target.value, rss.id)
                        }
                    >
                        <option value="">Select Size</option>
                        {sizes.filter(s => s.available === true && s.regions.includes(resources[i].region) && s.disk >= selectedPackage.resources[i].diskSize && s.description.toLowerCase() === "basic").map(s => (<option value={s.slug}>{s.description} | {s.slug} | ${this.state.billingType === 0 ? s.price_hourly.toFixed(3) : s.price_monthly.toFixed(2)} { this.state.billingType === 0 ? "per Hour":"per Month"}</option>))}
                        {sizes.filter(s => s.available === true && s.regions.includes(resources[i].region) && s.disk >= selectedPackage.resources[i].diskSize && s.description.toLowerCase() === "basic intel").map(s => (<option value={s.slug}>{s.description} | {s.slug} | ${this.state.billingType === 0 ? s.price_hourly.toFixed(3) : s.price_monthly.toFixed(2)} {this.state.billingType === 0 ? "per Hour" : "per Month"}</option>))}
                        {sizes.filter(s => s.available === true && s.regions.includes(resources[i].region) && s.disk >= selectedPackage.resources[i].diskSize && s.description.toLowerCase() === "basic amd").map(s => (<option value={s.slug}>{ s.description} | {s.slug} | ${this.state.billingType === 0 ? s.price_hourly.toFixed(3) : s.price_monthly.toFixed(2)} { this.state.billingType === 0 ? "per Hour":"per Month"}</option>))}
                    </select>
                </>}
            </div>
        );
    }

    // =========================
    // CONFIG
    // =========================
    renderConfig() {
        const pkg = this.getSelectedPackage();

        if (!pkg) return null;

        return (
            <div className="space-y-4">

                {/* HEADER */}
                <div className="flex justify-between items-center">
                    <div>
                        <div className="text-lg font-bold">
                            {pkg.name}
                        </div>
                    </div>
                </div>
                <hr />

                {/* NAME */}
                <label className="flex gap-2 text-sm items-start">Deployment Name</label>
                <input
                    className="w-full border p-2 rounded"
                    placeholder="Deployment Name"
                    value={this.state.serverName}
                    onChange={(e) =>
                        this.updateField("serverName", e.target.value)
                    }
                />

                {/* BILLING */}
                <label className="flex gap-2 text-sm items-start">Duration Type</label>
                <select
                    className="w-full border p-2 rounded"
                    value={this.state.billingType}
                    onChange={(e) =>
                        this.updateField("billingType", e.target.value)
                    }
                >
                    <option value="0">Hourly</option>
                    <option value="1">Monthly</option>
                    <option value="continous" disabled={true}>Continous (Not yet Supported)</option>
                </select>

                {/* DURATION */}
                <label className="flex gap-2 text-sm items-start">Duration Amount</label>
                <input
                    type="number"
                    className="w-full border p-2 rounded"
                    value={this.state.duration}
                    onChange={(e) =>
                        this.updateField("duration", e.target.value)
                    }
                />

                {/* ACTION */}
                <button
                    onClick={this.handleDeploy}
                    disabled={!this.state.isValid}
                    className="w-full py-3 rounded-lg text-white font-semibold bg-slate-900 disabled:bg-gray-400"
                >
                    {this.props.loading === true ? "Deploying, Please Wait...." : "Deploy Now" }
                </button>
            </div>
        );
    }

    // =========================
    // MAIN
    // =========================
    render() {
        const { packages } = this.props;
        const { selectedPackageId } = this.state;
        const hasSelection = !!selectedPackageId;

        return (
            <div className="max-w-7xl mx-auto p-6">

                {/* HEADER */}
                <div className="mb-4">
                    <h1 className="text-3xl font-bold">
                        Deploy System
                    </h1>
                </div>

                {/* TABS */}
                {!hasSelection && this.renderTabs()}
                {!hasSelection && (
                    <div className="mb-4 text-sm text-gray-500">
                        Select a package to view and configure deployment details.{" "}
                        <a
                            href="https://www.facebook.com/people/Haki-Automation/61590204219084/"
                            target="_blank"
                            className="text-slate-900 hover:underline font-medium"
                        >
                            Can’t find what you need? Request a package.
                        </a>
                    </div>
                )}
                {hasSelection && <div className="mb-4 text-sm text-gray-500">
                    Configure your deployment
                </div> }

                {/* GRID */}
                {/* ERROR */}
                {hasSelection && this.state.validationError && <>
                    <button
                        onClick={() =>
                            this.updateField("selectedPackageId", null)
                        }
                        className="text-sm text-slate-900"
                    >
                        ← Change Selection
                    </button>
                    <div className="text-red-500 text-sm">
                        {this.state.validationError}
                    </div>
                </>}
                <div
                    className={`grid gap-6 transition-all duration-300 ${hasSelection
                            ? "grid-cols-1 lg:grid-cols-4"
                            : "grid-cols-1"
                        }`}
                >

                    {/* PACKAGES */}
                    {!hasSelection && (<div className={hasSelection ? "lg:col-span-1" : ""}>
                        {this.renderPackages()}
                    </div>)}

                    {/* CONFIG */}
                    {hasSelection && <>

                        <div className="lg:col-span-2 border rounded-xl px-3 py-4 bg-white">
                            {this.renderConfig()}
                        </div>
                        <div className="lg:col-span-2 border rounded-xl px-3 py-4 bg-white">
                            {
                                packages.filter(p => p.id === selectedPackageId)[0]?.resources?.map((r,i) => this.renderConfigResource(r,i))
                            }
                        </div>
                    </>}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    packages: state.deploy.packages,
    regions: state.deploy.regions,
    sizes: state.deploy.sizes,
    loading: state.deploy.loading,
    credits: state.credits.balance
});

export default connect(mapStateToProps, {
    sendOrder,
    fetchPackages,
    fetchAvailability,
    fetchCredits
})(DeploymentV2);